import { useState } from 'react';
import { useIsMobile } from '../hooks/useIsMobile';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);
  const isMobile = useIsMobile();

  const handleSubmit = () => {
    if (!form.name || !form.email || !form.message) return;
    setSent(true);
  };

  return (
    <main style={{
      padding: isMobile ? '48px 20px' : '80px',
      minHeight: '70vh',
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
      gap: isMobile ? '48px' : '80px',
      alignItems: 'start',
    }}>
      <div>
        <h1 style={{ fontFamily: "'Josefin Sans', sans-serif", fontSize: '12px', letterSpacing: '4px', textTransform: 'uppercase', fontWeight: 300, marginBottom: '32px' }}>Contact</h1>
        <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '20px', lineHeight: '1.8', color: '#444', marginBottom: '40px' }}>
          Une question sur nos créations ? Nous sommes là pour vous aider.
        </p>
        <div style={{ fontFamily: "'Josefin Sans', sans-serif", fontSize: '11px', letterSpacing: '1.5px', color: '#888', lineHeight: '2' }}>
          <p>contact@norelio.com</p>
          <p>Maroc · Livraison nationale</p>
          <p>Réponse sous 24h</p>
        </div>
      </div>

      {sent ? (
        <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '22px', paddingTop: isMobile ? '0' : '60px' }}>
          Message envoyé. Merci !
        </div>
      ) : (
        <div>
          {[['name', 'Nom', 'Votre nom'], ['email', 'Email', 'votre@email.com']].map(([n, l, p]) => (
            <div key={n} style={{ marginBottom: '24px' }}>
              <label style={{ display: 'block', fontFamily: "'Josefin Sans', sans-serif", fontSize: '10px', letterSpacing: '2px', textTransform: 'uppercase', color: '#888', marginBottom: '8px' }}>{l}</label>
              <input value={form[n]} onChange={e => setForm(f => ({ ...f, [n]: e.target.value }))} placeholder={p}
                style={{ width: '100%', padding: '10px 0', border: 'none', borderBottom: '1px solid #ddd', outline: 'none', fontFamily: "'Cormorant Garamond', serif", fontSize: '17px', background: 'transparent', boxSizing: 'border-box' }} />
            </div>
          ))}
          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontFamily: "'Josefin Sans', sans-serif", fontSize: '10px', letterSpacing: '2px', textTransform: 'uppercase', color: '#888', marginBottom: '8px' }}>Message</label>
            <textarea value={form.message} onChange={e => setForm(f => ({ ...f, message: e.target.value }))} rows={5} placeholder="Votre message..."
              style={{ width: '100%', padding: '10px 0', border: 'none', borderBottom: '1px solid #ddd', outline: 'none', resize: 'none', fontFamily: "'Cormorant Garamond', serif", fontSize: '17px', background: 'transparent', boxSizing: 'border-box' }} />
          </div>
          <button onClick={handleSubmit} style={{
            padding: '14px 40px', background: '#111', color: '#fff', border: 'none', cursor: 'pointer',
            fontFamily: "'Josefin Sans', sans-serif", fontSize: '11px', letterSpacing: '3px', textTransform: 'uppercase',
            width: isMobile ? '100%' : 'auto',
          }}>Envoyer</button>
        </div>
      )}
    </main>
  );
}
